import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Link,
  Progress,
  Stack,
  useColorModeValue,
} from "@chakra-ui/react";
import Select from "react-select";
import MDEditor from "@uiw/react-md-editor";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import React, { useEffect, useState } from "react";
import { db, storage } from "../../firebaseConfig";
import { gadgetTypes, mobileBrandName } from "../../data/FilterData";

const AddEditForm = () => {
  const [reviews, setReviews] = useState<any>({
    Camera: { type: "Camera", rating: 0 },
    Battery: { type: "Battery", rating: 0 },
    Display: { type: "Display", rating: 0 },
    Design: { type: "Design", rating: 0 },
  });
  const [formData, setFormData] = useState<any>({
    brand: "",
    price: 0,
    model: "",
    gadType: "",
    description: "",
    rating: "",
    images: [],
    reviews: [],
    createdAt: Timestamp.now().toDate(),
  });

  const [imagePreview, setImagePreview] = useState<any>({
    images: [],
  });
  const [urls, setUrls] = useState<any[]>([]);
  const [progress, setProgress] = useState(0);
  const [brand, setBrand] = useState([]);
  const [gadgetTypesData, setGadgetTypesData] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");

  const FilterBrnad: any = mobileBrandName.map((brand) => ({
    value: brand.barndName,
    label: brand.barndName,
  }));
  const FilterGadgetTypes: any = gadgetTypes.map((type) => ({
    value: type.value,
    label: type.value,
  }));

  useEffect(() => {
    setBrand(FilterBrnad);
    setGadgetTypesData(FilterGadgetTypes);
  }, [FilterBrnad.length, FilterGadgetTypes.length]);

  function handleRatingChange(type: any, value: any) {
    setReviews((prevReviews: any) => ({
      ...prevReviews,
      [type]: { ...prevReviews[type], rating: value },
    }));
  }

  useEffect(() => {
    setFormData({
      ...formData,
      reviews: reviews,
    });
  }, [reviews]);

  const handleChange = (event: any) => {
    setFormData({
      ...formData,
      [event.target?.name]: event.target.value,
    });
  };
  const handleImageChange = (event: any) => {
    if (event.target.value && event.target.value.length) {
      setFormData({
        ...formData,
        images: [...formData.images, event.target.files[0]],
      });
      setImagePreview({
        ...imagePreview,
        images: [
          ...imagePreview.images,
          URL.createObjectURL(event.target.files[0]),
        ],
      });
    }
  };

  const handlePublish = async () => {
    const {
      description,
      images,
      price,
      model,
      gadType,
      rating,
      reviews,
      brand,
    } = formData;

    const uploadTasks = images.map((image: any) => {
      const storageRef = ref(storage, `/images/${Date.now()}${image.name}`);
      const uploadTask = uploadBytesResumable(storageRef, image);

      uploadTask.on("state_changed", (snapshot: any) => {
        const progressPercent = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progressPercent);
      });

      return uploadTask;
    });

    await Promise.all(uploadTasks);

    const urls = await Promise.all(
      uploadTasks.map((uploadTask: any) =>
        getDownloadURL(uploadTask.snapshot.ref)
      )
    );

    const articleRef = collection(db, "Articles");
    await addDoc(articleRef, {
      brand,
      price,
      model,
      gadType,
      description,
      rating,
      reviews,
      images: urls,
      createdAt: Timestamp.now().toDate(),
    });

    setFormData({
      brand: "",
      price: 0,
      model: "",
      gadType: "",
      description: "",
      rating: "",
      images: [],
      reviews: [],
    });

    setUrls((prevState) => [...prevState, ...urls]);
    alert("Data Added Successfully");
    setProgress(0);
  };

  return (
    <div className="border p-3 mt-3 bg-light">
      {/* Chakra */}
      <Flex
        align={"center"}
        justify={"center"}
        bg={useColorModeValue("gray.50", "gray.800")}
      >
        <Stack spacing={8} width={1000} py={12} px={6}>
          <Stack align={"center"}>
            <Heading fontSize={"4xl"}>Add a NEw RECORD</Heading>
          </Stack>
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow={"lg"}
            p={8}
          >
            <Stack spacing={4}>
              <FormControl id="brand">
                <FormLabel>Brand name</FormLabel>
                <Select
                  className="select"
                  options={brand}
                  placeholder="Select Brand"
                  name="brand"
                  onChange={(e: any) =>
                    setFormData({ ...formData, brand: e.value })
                  }
                />
              </FormControl>
              <FormControl id="price">
                <FormLabel>Price</FormLabel>
                <Input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={(e: any) =>
                    setFormData({ ...formData, price: +e.target.value })
                  }
                />
              </FormControl>
              <FormControl id="model">
                <FormLabel>Model</FormLabel>
                <Input
                  type="model"
                  name="model"
                  value={formData.model}
                  onChange={(e) => handleChange(e)}
                />
              </FormControl>
              <FormControl id="gadType">
                <FormLabel>Gadget type</FormLabel>
                <Select
                  className="select"
                  options={gadgetTypesData}
                  placeholder="Select Gadget Type"
                  onChange={(e: any) =>
                    setFormData({ ...formData, gadType: e.value })
                  }
                />
              </FormControl>
              <FormControl id="rating">
                <FormLabel>Avg rating</FormLabel>
                <Input
                  type="number"
                  name="rating"
                  value={formData.rating}
                  onChange={(e) => handleChange(e)}
                />
              </FormControl>
              <FormControl id="description">
                <FormLabel>Description</FormLabel>
                <div data-color-mode="light">
                  <MDEditor
                    value={formData.description}
                    onChange={(val) => {
                      setFormData({ ...formData, description: val! });
                    }}
                  />
                </div>
              </FormControl>
              <FormControl id="model">
                <FormLabel>Images</FormLabel>
                <Input
                  type="file"
                  accept="image/*"
                  name="images"
                  onChange={(e) => handleImageChange(e)}
                  multiple
                />
              </FormControl>
              <div className="image-preview mt-4">
                {imagePreview.images.map((image: any) => {
                  return <img src={image} alt="" className="w-25" />;
                })}
              </div>
              <Progress hasStripe value={progress} colorScheme="green" />
              <FormLabel>Review</FormLabel>
              <FormControl id="camera" display={"flex"}>
                <Input type="type" value={"Camera"} />
                <Input
                  type="number"
                  ml={2}
                  value={reviews.Camera.rating}
                  onChange={(e) => handleRatingChange("Camera", e.target.value)}
                />
              </FormControl>
              <FormControl id="Battery" display={"flex"}>
                <Input type="type" value={"Battery"} />
                <Input
                  type="number"
                  ml={2}
                  value={reviews.Battery.rating}
                  onChange={(e) =>
                    handleRatingChange("Battery", e.target.value)
                  }
                />
              </FormControl>
              <FormControl id="Display" display={"flex"}>
                <Input type="type" value={"Display"} />
                <Input
                  type="number"
                  ml={2}
                  value={reviews.Display.rating}
                  onChange={(e) =>
                    handleRatingChange("Display", e.target.value)
                  }
                />
              </FormControl>
              <FormControl id="Design" display={"flex"}>
                <Input type="type" value={"Design"} />
                <Input
                  type="number"
                  ml={2}
                  value={reviews.Design.rating}
                  onChange={(e) => handleRatingChange("Design", e.target.value)}
                />
              </FormControl>
              <Stack spacing={10}>
                <Button
                  bg={"#ff5733"}
                  color={"white"}
                  _hover={{
                    bg: "#f93e13",
                  }}
                  onClick={handlePublish}
                >
                  Publish
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </div>
  );
};

export default AddEditForm;
